import { Component, OnInit, Inject } from '@angular/core';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReservationSearchItem } from 'src/app/model/reservation-search-item';

@Component({
  selector: 'app-patient-reservations-dialog',
  templateUrl: './patient-reservations-dialog.component.html',
  styleUrls: ['./patient-reservations-dialog.component.css']
})
export class PatientReservationsDialogComponent implements OnInit {

  constructor(private reservationService: ReservationService
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<PatientReservationsDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: ReservationSearchItem[]) { }

  ngOnInit() {
  }
  
  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
